module.exports = __webpack_public_path__ + "img/3_1ddd5097e.png";